import {DomainUri} from '../../state/types/domain-registry.js';
import {reason} from '../../reason.js';

export const agmDomainUri: DomainUri = 'agm';
export const agmFailure = `${agmDomainUri}.errors.failure`;

export const agmUnhandledMessage = `${agmDomainUri}.errors.unhandled_message`;
export const agmUnregistrationFailure = `${agmDomainUri}.errors.unregistration.failure`;
export const agmInvocationFailure = `${agmDomainUri}.errors.invocation.failure`;
export const agmSubscriptionFailure = `${agmDomainUri}.errors.subscription.failure`;
export const agmInvalidSubscription =  `${agmDomainUri}.errors.subscription.invalid_subscription`;
export const reasonPeerRemoved = reason(`${agmDomainUri}.peer-removed`, 'Peer has been removed');
export const reasonMethodRemoved = reason(`${agmDomainUri}.method-removed`, 'Method has been removed');
export const reasonBadDrop = reason(agmInvalidSubscription, 'Trying to drop a subscription that wasnt established. Did you mean to return an error instead?');
